<div class="card" [formGroup]="form">
  <div class="card-header">
    {{ title }}
  </div>

  <div class="card-block">
    <div class="clr-row">
      <subs-static-text
        class="clr-col-7"
        label="* First name"
        controlName="firstName"
      ></subs-static-text>

      <subs-static-text
        class="clr-col-5"
        controlName="middleName"
        labelStyle="width: 4rem;"
      >
      </subs-static-text>
    </div>

    <div class="clr-row">
      <subs-static-text
        class="clr-col-7"
        label="* Last name"
        controlName="lastName"
      ></subs-static-text>

      <subs-static-text
        class="clr-col-5"
        controlName="nameSuffix"
        labelStyle="width: 4rem;"
      >
      </subs-static-text>
    </div>

    <div class="clr-row">
      <subs-static-text
        class="clr-col-7"
        label="* Phone"
        controlName="phone"
      ></subs-static-text>

      <subs-static-text
        class="clr-col-5"
        controlName="fax"
        labelStyle="width: 4rem;"
      ></subs-static-text>
    </div>

    <div class="clr-row">
      <subs-static-text
        class="clr-col"
        label="* Email address"
        controlName="emailAddress"
      ></subs-static-text>

      <subs-static-text
        class="clr-col-5"
        *ngIf="this.form.contains('invoiceEmail')"
        label="Invoice email"
        controlName="invoiceEmail"
      ></subs-static-text>
    </div>

    <subs-readonly-address
      [form]="form.controls.address"
    ></subs-readonly-address>
  </div>
</div>
